<template>
  <div class="carousel-edit w-full flex items-center justify-center rounded-2">
    <CIcon :color="themeVars.primary4" :icon="ComponentIcon.Carousel" size="36px" />
  </div>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import { ComponentIcon } from '@canvas-builder/types/canvas'

const themeVars = useThemeVars()
</script>

<style scoped lang="scss">
.carousel-edit {
  height: 100px;
  background: v-bind('themeVars.primary6');
}
</style>
